import { IPublicClientApplication } from '@azure/msal-browser';
import { Organization } from '../../models';
import { ApiEndpointCallStatesStore } from '../api-endpoint-call-states-store';
import { FetchContext } from '../fetch-context';
import { promiseWithObservableState } from '../promise-with-observable-state';
import { withApiAccessToken } from '../with-api-access-token';
import { updateNominationOrganization, updateOrganization } from './index';

export const createNominationOrganizationsApiEndpoints = (
  fetchContext: FetchContext,
  apiEndpointCallStates: ApiEndpointCallStatesStore,
) => ({
  updateNominationOrganization: (instance: IPublicClientApplication, nominationId: number, organization: Organization) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateNominationOrganization(fetchContext, nominationId, organization, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateNominationOrganization', isInFlight);
    },
  ),
  updateOrganization: (instance: IPublicClientApplication, organization: Organization) => promiseWithObservableState(
    withApiAccessToken(
      instance,
      (accessToken) => updateOrganization(fetchContext, organization, accessToken),
    ),
    (isInFlight) => {
      apiEndpointCallStates.setIsInFlight('updateOrganization', isInFlight);
    },
  ),
});
